// Debug logger pour capturer les rechargements automatiques
export class DebugLogger {
  private static logs: Array<{
    timestamp: string;
    type: 'navigation' | 'reload' | 'auth' | 'error';
    message: string;
    details?: any;
  }> = [];

  static log(type: 'navigation' | 'reload' | 'auth' | 'error', message: string, details?: any) {
    const timestamp = new Date().toISOString();
    const logEntry = { timestamp, type, message, details };
    
    this.logs.push(logEntry);
    
    // Garder seulement les 100 derniers logs
    if (this.logs.length > 100) {
      this.logs = this.logs.slice(-100);
    }
    
    // Console log avec couleur selon le type
    const color = {
      navigation: '#2563eb', // bleu
      reload: '#dc2626',    // rouge
      auth: '#16a34a',      // vert  
      error: '#ea580c'      // orange
    }[type];
    
    console.log(
      `%c[${type.toUpperCase()}] ${message}`,
      `color: ${color}; font-weight: bold`,
      details || ''
    );
  }

  static getRecentLogs(count = 20) {
    return this.logs.slice(-count);
  }

  static clearLogs() {
    this.logs = [];
  }

  // Capturer les rechargements
  static trackPageReloads() {
    // Détecter les rechargements complets
    const navigationEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    if (navigationEntries.length > 0) {
      const navEntry = navigationEntries[0];
      if (navEntry.type === 'reload') {
        this.log('reload', 'Page rechargée complètement', {
          navigationType: navEntry.type,
          loadEventEnd: navEntry.loadEventEnd
        });
      }
    }
    
    // Capturer les changements d'URL
    let currentUrl = window.location.href;
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    
    window.history.pushState = function(...args) {
      const newUrl = args[2]?.toString() || window.location.href;
      DebugLogger.log('navigation', 'Navigation via pushState', {
        from: currentUrl,
        to: newUrl,
        state: args[0]
      });
      currentUrl = newUrl;
      return originalPushState.apply(window.history, args);
    };
    
    window.history.replaceState = function(...args) {
      const newUrl = args[2]?.toString() || window.location.href;
      DebugLogger.log('navigation', 'Navigation via replaceState', {
        from: currentUrl,
        to: newUrl,
        state: args[0]
      });
      currentUrl = newUrl;
      return originalReplaceState.apply(window.history, args);
    };
    
    // Capturer les erreurs qui peuvent déclencher des rechargements
    window.addEventListener('error', (event) => {
      this.log('error', 'Erreur JavaScript détectée', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        stack: event.error?.stack
      });
    });
    
    window.addEventListener('unhandledrejection', (event) => {
      this.log('error', 'Promise rejection non gérée', {
        reason: event.reason?.toString(),
        stack: event.reason?.stack
      });
    });
  }
}

// Initialiser le tracking dès le chargement
if (typeof window !== 'undefined') {
  DebugLogger.trackPageReloads();
  
  // Log du démarrage
  DebugLogger.log('reload', 'Application initialisée', {
    url: window.location.href,
    userAgent: navigator.userAgent,
    timestamp: new Date().toISOString()
  });
}